import { render, staticRenderFns } from "./InitialCount.vue?vue&type=template&id=79957212&"
import script from "./InitialCount.vue?vue&type=script&lang=js&"
export * from "./InitialCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports